import type { BufferCode } from '../../api/marking';

// Единое правило продажи марки (marking_buffer.md §3, rev. 2026-10-23):
// в документ (любой вид — ЗН, замена масла, быстрая оплата; любой путь — буфер,
// скан в открытую форму, префилл) piece-марка попадает только в статусе ready.
// Возвращает причину отказа или null. Backend-барьеры: /check и bind_mark (409).
export const sellabilityError = (
  r: Pick<BufferCode, 'product_type' | 'status' | 'order_id' | 'order_number'>,
): string | null => {
  if (r.product_type === 'unknown') {
    return 'Сначала определите товар и тару марки в 1С/GTIN-привязке';
  }
  if (r.product_type === 'bulk') {
    return 'Разливной товар добавляется по номенклатуре: выберите товар и укажите объём — марки подберутся автоматически';
  }
  if (r.order_id != null) {
    return `Эта бутылка уже в заказе${r.order_number ? ` № ${r.order_number}` : ''}`;
  }
  if (r.status === 'sold') return 'Марка уже продана';
  if (r.status === 'written_off') return 'Марка списана (выведена из оборота)';
  if (r.status === 'reserved') return 'Марка зарезервирована другим документом';
  if (r.status === 'off_balance') return 'Марка вне баланса 1С (нет в справочнике 1С)';
  return null;
};
